import { datadogRum } from '@datadog/browser-rum'

export default {
  rum: {
    async init() {
      try {
        datadogRum.init({
          applicationId: 'e4ebb415-d740-40c7-adf3-340d3950aba6',
          clientToken: 'pub4a2caee6cc9e761705c9e78ab04b3c38',
          service: 'default',
          site: 'datadoghq.eu',
          env: process.env.REACT_APP_ENV,
          version: process.env.REACT_APP_VERSION,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          defaultPrivacyLevel: 'mask-user-input'
        })

        console.log(
          `Datadog service - frontend ${process.env.REACT_APP_VERSION} ${process.env.REACT_APP_ENV} RUM initialised!`
        )
      } catch (err: any) {
        console.error(`Datadog service - ${err.message}`)
      }
    }
  }
}
